document.addEventListener('click', function(e) {
  const button = e.target.closest('button[type="submit"]');
  
  if (button) {
    const form = button.closest('form');
    
    if (form && form.getAttribute('action') === '/cart/add') {
      let productData;
      
      if (document.body.classList.contains('product')) {
        productData = getProductPageData(form);
      } else {
        productData = getProductTileData(button, form);
      }
      
      if (productData && productData.imageSrc) {
        // Image is already loaded in DOM, append immediately
        appendDummyItem(productData);
      }

      const cartButton = document.getElementById('CartButton');
      if (cartButton) {
        cartButton.click();
      }
    }
  }
});

function appendDummyItem(productData) {
  const dummyCartItem = createDummyCartItem(productData);
  
  const emptyContainer = document.querySelector('.empty-cart');
  if (emptyContainer) {
    emptyContainer.classList.add('opacity-class');
    emptyContainer.appendChild(dummyCartItem);
  } else {
    const cartItemsList = document.querySelector('[\\:key="cart-items"]');
    if (cartItemsList) {
      cartItemsList.classList.add('opacity-class');
      const firstLi = cartItemsList.querySelector('li');
      if (firstLi) {
        cartItemsList.insertBefore(dummyCartItem, firstLi);
      } else {
        cartItemsList.appendChild(dummyCartItem);
      }
    }
  }
  
  // Start checking for error message
 /* let checkCount = 0;
  const maxChecks = 4; // 6 checks * 500ms = 3 seconds
  
  const intervalId = setInterval(() => {
    checkCount++;
    
    // Look for error message div with x-text="cartAddErrorMessage"
    const errorDiv = document.querySelector('[x-text="cartAddErrorMessage"]');
    const hasError = errorDiv && errorDiv.textContent.trim() !== '';
    
    // Remove dummy if error found OR max time reached
    if (hasError || checkCount >= maxChecks) {
      // Remove the specific dummy item
      if (dummyCartItem && dummyCartItem.parentNode) {
        dummyCartItem.remove();
      }
      
      // Check if any dummy items remain
      const remainingDummies = document.querySelectorAll('.dummy-cart-item');
      if (remainingDummies.length === 0) {
        const emptyContainer = document.querySelector('.empty-cart');
        if (emptyContainer) {
          emptyContainer.classList.remove('opacity-class');
        }
        
        const cartItemsList = document.querySelector('[\\:key="cart-items"]');
        if (cartItemsList) {
          cartItemsList.classList.remove('opacity-class');
        }
      }
      
      // Clear the interval
      clearInterval(intervalId);
    }
  }, 500);*/
}

function getProductPageData(form) {
  const featureMedia = document.querySelector('.feature-media-item img');
  
  // Get the smallest image from srcset or fallback to src
  let imageSrc = null;
  let imageElement = null;
  if (featureMedia) {
    imageElement = featureMedia; // Store reference to actual image element
    if (featureMedia.srcset) {
      const srcsetArray = featureMedia.srcset.split(',').map(s => s.trim());
      const smallestSrc = srcsetArray[0].split(' ')[0]; // First entry is usually smallest
      imageSrc = smallestSrc;
    } else {
      imageSrc = featureMedia.src;
    }
  }
  
  const imageAlt = featureMedia ? featureMedia.alt : null;
  
  const titleElement = document.querySelector('.product-block-title');
  const productTitle = titleElement ? titleElement.textContent.trim() : null;
  
  const priceElement = document.querySelector('.product-block-price [data-product-price]');
  const price = priceElement ? priceElement.textContent.trim() : null;
  
  const selectedVariantInput = document.querySelector('.product-variant-picker-block input[type="radio"]:checked');
  const selectedVariant = selectedVariantInput ? selectedVariantInput.value : null;
  
  const variantId = form.querySelector('select[name="id"] option:checked')?.value || 
                   form.querySelector('input[name="id"]')?.value;
  
  const productUrl = '#';
  
  return {
    variantId,
    productTitle,
    imageSrc,
    imageAlt,
    price,
    selectedVariant,
    productUrl,
    imageElement
  };
}

function getProductTileData(button, form) {
  const productTile = button.closest('.product-tile__container');
  
  if (!productTile) {
    return null;
  }
  
  const img = productTile.querySelector('.product-tile__featured-media img');
  
  // Get the smallest image from srcset or fallback to src
  let imageSrc = null;
  let imageElement = null;
  if (img) {
    imageElement = img; // Store reference to actual image element
    if (img.srcset) {
      const srcsetArray = img.srcset.split(',').map(s => s.trim());
      const smallestSrc = srcsetArray[0].split(' ')[0]; // First entry is usually smallest
      imageSrc = smallestSrc;
    } else {
      imageSrc = img.src;
    }
  }
  
  const imageAlt = img ? img.alt : null;
  
  const priceElement = productTile.querySelector('[data-product-price]');
  const price = priceElement ? priceElement.textContent.trim() : null;
  
  const selectedVariantInput = form.querySelector('input[type="radio"]:checked');
  const selectedVariant = selectedVariantInput ? selectedVariantInput.value : null;
  const variantId = form.querySelector('select[name="id"] option:checked')?.value || 
                   form.querySelector('input[name="id"]')?.value;
  
  const titleElement = productTile.querySelector('.font-body.text-base');
  const productTitle = titleElement ? titleElement.textContent.trim() : null;
  
  const productLink = productTile.querySelector('.product-tile__featured-media');
  const productUrl = productLink ? productLink.getAttribute('href') : '#';
  
  return {
    variantId,
    productTitle,
    imageSrc,
    imageAlt,
    price,
    selectedVariant,
    productUrl,
    imageElement
  };
}

function createDummyCartItem(data) {
  const { variantId, productTitle, imageSrc, imageAlt, price, selectedVariant, productUrl, imageElement } = data;
  
  const lineItemKey = `${variantId}:${generateRandomHash()}`;
  
  const li = document.createElement('li');
  li.className = 'grid grid-cols-4 gap-2.5 xl:gap-5 auto-rows-max lg:auto-rows-min lg:grid-cols-5 py-2.5 lg:py-5 halfopcaity dummy-cart-item';
  li.setAttribute('x-data', `CartItem('${lineItemKey}')`);
  li.setAttribute('key', `CartItem-1-${lineItemKey}`);
  li.setAttribute('id', `CartItem-1-${lineItemKey}`);
  li.setAttribute('data-line-item-key', lineItemKey);
  
  li.innerHTML = `
    <div class="col-span-1 lg:col-span-2 row-span-2" data-image-container>
      <a href="${productUrl}?variant=${variantId}" class="block" aria-hidden="true" tabindex="-1">
        <img src="${imageSrc}" alt="${imageAlt}" width="200" height="200" loading="eager" decoding="sync" sizes="(min-width: 48em) 5rem, 3.5rem" class="media__styled-element">
      </a>
    </div>
    <div class="col-span-2">
      <div>
        <a href="${productUrl}?variant=${variantId}">
          <div data-product-title="">
            <p class="text-sm leading-tight lg:text-base">
              ${productTitle}
            </p>
            ${selectedVariant ? `<p class="mt-1 text-xs">${selectedVariant}</p>` : ''}
          </div>
        </a>
      </div>
      <div x-data="CartItemQuantity" x-ref="quantityControl" @remove="remove" class="max-w-min">
        <div class="ml-[0.1rem] mt-2.5 lg:mt-5">
          <label class="sr-only" for="updates_${lineItemKey}">Quantity:</label>
          <div class="input flex h-8 max-w-min flex-nowrap items-stretch justify-center p-0 text-xs text-scheme-text lg:text-base">
            <button class="h-full w-8" aria-label="−" @click.prevent.stop="decrement">
              <div class="m-auto h-2 w-2 lg:h-4 lg:w-4">
                <svg class="theme-icon" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path vector-effect="non-scaling-stroke" d="M46 24H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
            </button>
            <input type="number" name="updates[]" id="updates_${lineItemKey}" value="1" data-variant-id="${variantId}" data-last-value="1" class="w-12 border-0 bg-transparent text-center text-sm shadow-none focus:ring-current lg:text-base" size="4" min="1" step="1" aria-label="Quantity" x-ref="quantityInput" x-model.number.fill="quantity" @change="itemQuantityChange()" @keyup.debounce.750ms="$dispatch('change')" autocomplete="off">
            <button class="h-full w-8" aria-label="+" @click.prevent.stop="increment">
              <div class="m-auto h-2 w-2 lg:h-4 lg:w-4">
                <svg class="theme-icon" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path vector-effect="non-scaling-stroke" d="M24 2V46" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path vector-effect="non-scaling-stroke" d="M46 24H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
            </button>
          </div>
        </div>
        <div>
          <p class="text-xs mt-1.5 lg:mt-2.5">
            <a href="javascript:void(0)" @click.prevent="remove" class="aca-cco" aca-line="1" aca-quantity="0" onclick="return false;">
              Remove
            </a>
          </p>
        </div>
      </div>
    </div>
    <div class="col-start-4 row-start-1 lg:col-start-5 break-words text-right text-sm leading-tight lg:text-base">
      ${price}
    </div>
    <div class="col-span-full mt-1" id="Line-item-error-${lineItemKey}" role="alert" data-item-title="${imageAlt}" style="display: none;" x-show="errorMessage">
      <div class="w-fit rounded-button bg-scheme-accent-1 px-2 py-1 text-xs text-scheme-accent-1-contrast" x-text="errorMessage"></div>
    </div>
  `;
  
  // Clone the actual loaded image element and replace the placeholder
  if (imageElement && imageElement.complete) {
    const imageContainer = li.querySelector('[data-image-container] a');
    if (imageContainer) {
      const clonedImg = imageElement.cloneNode(true);
      clonedImg.width = 200;
      clonedImg.height = 200;
      clonedImg.loading = 'eager';
      clonedImg.setAttribute('decoding', 'sync');
      clonedImg.sizes = '(min-width: 48em) 5rem, 3.5rem';
      clonedImg.className = 'media__styled-element';
      
      // Replace the placeholder image with the cloned one
      const placeholderImg = imageContainer.querySelector('img');
      if (placeholderImg) {
        imageContainer.replaceChild(clonedImg, placeholderImg);
      }
    }
  }
  
  return li;
}

function generateRandomHash() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

function removeDummyItems() {
  
  const dummyItems = document.querySelectorAll('.dummy-cart-item');
  if (dummyItems.length > 0) {
    dummyItems.forEach(item => item.remove());
  }
  
  
  const emptyContainer = document.querySelector('.empty-cart');
  if (emptyContainer && emptyContainer.classList.contains('opacity-class')) {
    emptyContainer.classList.remove('opacity-class');
  }
  
  const cartItemsList = document.querySelector('[\\:key="cart-items"]');
  if (cartItemsList && cartItemsList.classList.contains('opacity-class')) {
    cartItemsList.classList.remove('opacity-class');
  }
}


document.addEventListener("theme:cart-drawer:closing", function (event) {
 removeDummyItems()
});



/*let cartBtn = document.getElementById('CartButton');
if (cartBtn) {
    cartBtn.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof window.OPEN_CART === 'function') {
            //window.OPEN_CART();
            dispatchEvent(new Event('ocu:cart:open'));
        }
    });
}

class SubscribeCartChange {
    callback;
    events = {
        'ocu:cart:changing': 'ocu:product:added',
        'ocu:cart:update': 'ocu:cart:updated',
    };
    constructor(callback) {
        this.callback = callback;
        this.subscribe();
    }
    listen(event) {
        addEventListener(event, this.callback, { once: true });
    }
    subscribe() {
        Object.entries(this.events).forEach(([start, end]) => {
            addEventListener(start, () => this.listen(end));
        });
    }
}


function handleCartEvents(event) {
    if (event.type === 'ocu:product:added') {
       document.dispatchEvent(new Event("theme:update:cart"));

    } else if (event.type === 'ocu:cart:updated') {
      document.dispatchEvent(new Event("theme:update:cart"));  
    }
}


new SubscribeCartChange(handleCartEvents);
*/